module.exports = __webpack_public_path__ + "aea1d33bcd9559e34d80abe0e5bf7276.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/images/studio1.jpg
// module id = 539
// module chunks = 0